import { connect } from 'react-redux';

import {
  projectGet,
  projectGetProducts,
  projectUpdateProduct,
  shoppingCartSendProducts,
} from 'actions';

import View from './';

const mapStateToProps = (state) => {
  return {
    intl: state.intl,
    products: state.projects.products,
    project: state.projects.single,
    shoppingCartToken: state.shoppingCartToken,
    shoppingCartIsLoading: state.shoppingCartIsLoading,
    shoppingCartError: state.shoppingCartError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    projectGet(payload) {
      return dispatch(projectGet(payload));
    },
    projectGetProducts(...params) {
      return dispatch(projectGetProducts(...params));
    },
    projectUpdateProduct(...params) {
      return dispatch(projectUpdateProduct(...params));
    },
    shoppingCartSendProducts(...params) {
      return dispatch(shoppingCartSendProducts(...params));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/views/systems/detail/quote/container.js